export default __webpack_public_path__ + "static/expression-light-0196b09d14ba052ba87cdc2fe9272b45.png";